import React, { FC, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { updateLangStatus } from '../../../states/containers/common/langStatusSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useAlert } from 'react-alert'
import { RootState } from '../../../states/containers/store'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'

const LangInfo: FC = () => {
  const { t, i18n } = useTranslation()
  const alert = useAlert()
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    commonPart,
    langStatus,
  } = useSelector((state: RootState) => (state))

  const initialLangValues = commonPart.company?.language || 'ja'

  const [selectLang, setSelectLang] = useState<string>(initialLangValues)

  const handleLangStatusSubmit = () => {
    if (selectLang === commonPart.company?.language) return
    dispatch(
      updateLangStatus(
        { language: selectLang as "ja" | "en" },
        () => {
          alert.success(t('setting.common.language.updated'))
        },
      ),
    )
  }
  return (
    <>
      <div className="select" style={{width: "30%"}}>
        <select
          onChange={(value) => {
            setSelectLang(value.currentTarget.value)
          }}
          defaultValue={selectLang}
        >
          <option value="ja">日本語</option>
          <option value="en">English</option>
        </select>
      </div>
      <button
        type="button"
        className="mt-4 button"
        disabled={langStatus.isLoading}
        onClick={handleLangStatusSubmit}
      >
        {t('setting.common.language.button_text')}
      </button>
    </>
  )
}

export default LangInfo
